module.exports = __webpack_public_path__ + "img/PEAK-Logo.e3b1bfed.png";